/**
 * Persistence schema version for the ArtworkDocument.
 *
 * Kept in the CORE (not the persistence adapter) so the core stays
 * self-contained and unit-testable, and so both the engine and the IndexedDB
 * store agree on one source of truth. Bump this and add a migration in
 * persistence/schema.ts whenever the document shape changes. See SAVE_SCHEMA.md.
 */
export const SCHEMA_VERSION = 1;
